// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"74":"bc3182bb","84":"eebcd069","200":"c27857e5","400":"4430e236","526":"48518ac8","549":"54410722","563":"45d40d72","911":"861483e0"}[chunkId] + ".chunk.js";
};